import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const TickRoundFilled = ({ color = 'var(--brand-bg-primary)', ...props }: IconProps) => {
  return (
    (<svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      data-palette="TickRoundFilled">
      <path
        d="M7.00065 13.6667C3.31865 13.6667 0.333984 10.682 0.333984 7C0.333984 3.318 3.31865 0.333336 7.00065 0.333336C10.6827 0.333336 13.6673 3.318 13.6673 7C13.6673 10.682 10.6827 13.6667 7.00065 13.6667ZM6.33598 9.66667L11.0493 4.95267L10.1067 4.01L6.33598 7.78134L4.44998 5.89534L3.50732 6.838L6.33598 9.66667Z"
        fill={color}
      />
    </svg>)
  );
};

export default TickRoundFilled;
